import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import WestRockHeader from '../../components/WestRockHeader';
import TamperTesterLogo from './tamper_tester_logo.svg';

function Home(props) {
	const theme = useTheme();
	const { t } = useTranslation();

	return (
		<>
			<WestRockHeader />
			<Box
				style={{
					display: 'flex',
					justifyContent: 'center',
					background: theme.palette.primary.main,
					paddingTop: theme.spacing(8),
					paddingBottom: theme.spacing(10),
				}}
			>
				<img src={TamperTesterLogo} alt="Tamper Tester" />
			</Box>
			<Box
				style={{
					background: 'white',
					borderTopRightRadius: 22,
					borderTopLeftRadius: 22,
					position: 'relative',
					top: -22,
				}}
			>
				<Container
					maxWidth="sm"
					style={{
						display: 'flex',
						flexDirection: 'column',
						flex: 1,
						justifyContent: 'space-between',
					}}
				>
					<Typography
						variant="h3"
						component="h1"
						gutterBottom
						color="primary"
						style={{
							textAlign: 'center',
							marginTop: theme.spacing(4),
						}}
					>
						{t('home_screen.title')}
					</Typography>
					<Typography variant="body1" style={{ textAlign: 'center' }}>
						{t('home_screen.description')}
					</Typography>

					<Button
						component={Link}
						to="/step1"
						variant="contained"
						color="primary"
						fullWidth={true}
						style={{
							marginBottom: theme.spacing(1),
							marginTop: theme.spacing(4),
						}}
					>
						{t('home_screen.start_scan')}
					</Button>
					<Button
						component={Link}
						to="/help"
						variant="outlined"
						fullWidth={true}
					>
						{t('home_screen.getting_started')}
					</Button>
				</Container>
			</Box>
		</>
	);
}

export default Home;
